import DashboardLayout from "../../../../Layouts/DashboardLayout";
import ContentBodyWrapper from "../../../../Layouts/Containers/ContentBodyWrapper";
import ContentBodyHeader from "../../../../Layouts/Containers/ContentBodyHeader";
import RoleTable from "./RoleTable";
import reactRouteList from "../../../../config/react-route-list-config";
import { useTranslation } from "react-i18next";
import { permissionCheck } from "../../../../utils/permission";
import { changeBrowserTabTitle } from "../../../../utils/Browser";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";
export default function RoleListPage() {
    changeBrowserTabTitle("Roles");
    const [t] = useTranslation();

    const buttons = (
        <ButtonBlack
            to={reactRouteList.loggedRoutes.create_roles}
            icon={"material-symbols:add"}
        >
            {t("New")}
        </ButtonBlack>
    );
    return (
        <>
            <DashboardLayout>
                <ContentBodyWrapper showFooter={true}>
                    <ContentBodyHeader
                        info={{
                            title: t("Roles"),
                        }}
                        breadcrumb={[
                            {
                                linkitem: t("Roles"),
                                link: reactRouteList.loggedRoutes.role_list,
                            }
                        ]}
                        buttons={permissionCheck("role create") && buttons}
                    />
                    <RoleTable />
                </ContentBodyWrapper>
            </DashboardLayout>
        </>
    );
}
